
import {Bank} from "@/models/base";
import Vue from "vue";
import AppBankEditDefault from "./BankEditDefault.vue";

export default Vue.extend({
	props: {
		bank: {
			type: Object as ()=>Bank,
			required: true,
		},
		history: Array as () => Bank[],
		clearBatch: {
			type: Number,
			required: false,
		},
	},
	methods: {
		onUpdate(value:any){
			this.$emit("update",value);
		},
		openSaveFavorite(){
			(this.$refs.bankEdit as any).openSaveFavoriteModal();
		}
	},
	components: {
		AppBankEditDefault
	},
	i18nEx: {
		componentPrefix: "components.bank"
	}
});
